import { useQuery } from '@apollo/client';

import WeekToModuleStatusQuery from 'bundles/custom-labels/queries/CourseIsWeekToModuleEnabled.graphql';
import type {
  WeekToModuleStatusQuery as WeekToModuleStatusQueryResponse,
  WeekToModuleStatusQueryVariables,
} from 'bundles/custom-labels/queries/__generated__/CourseIsWeekToModuleEnabled';

export type UseIsWeekToModuleEnabledForCourseOptions = {
  /** When true, skip the WeekToModuleStatus query. Return value is defaultValueWhenSkipped when skipped. */
  skipQuery?: boolean;
  /** When skipQuery is true, return this value instead of querying. Use true to default to "Module" terminology when the query is skipped (e.g. enableCustomLabels is false). */
  defaultValueWhenSkipped?: boolean;
};

export const useIsWeekToModuleEnabledForCourse = (
  courseId: string | undefined,
  options?: UseIsWeekToModuleEnabledForCourseOptions
): boolean => {
  const skipQuery = options?.skipQuery ?? false;
  const defaultValueWhenSkipped = options?.defaultValueWhenSkipped ?? false;

  const { data } = useQuery<WeekToModuleStatusQueryResponse, WeekToModuleStatusQueryVariables>(
    WeekToModuleStatusQuery,
    {
      variables: { courseId: `${courseId}` },
      context: { clientName: 'gatewayGql' },
      skip: !courseId || skipQuery,
    }
  );

  if (!courseId || skipQuery) {
    return defaultValueWhenSkipped;
  }
  return !!data?.Course?.queryById?.isWeekToModuleEnabledForCourse;
};
